import { BcCalendarEvent, BcCalendarResource, BcCalendarSettings } from '@bayclubs/calendar';
import { GetGroupClassesCalendarQuery } from '@bayclubs/group-classes-employee-api';

export enum ClassesCalendarActionTypes {
  LoadClassesCalendar = '[ClassesCalendar] Load classes calendar action',
  LoadClassesCalendarSuccess = '[ClassesCalendar] Load classes calendar success action',
  LoadClassesCalendarContext = '[ClassesCalendar] Load classes calendar context action',
  LoadClassesCalendarContextSuccess = '[ClassesCalendar] Load classes calendar context success action',
  InitClassesCalendarFiltersForm = '[ClassesCalendar] Init classes calendar filters form',
  SetSelectedClubId = '[ClassesCalendar] Set selected club id'
}

export class SetSelectedClubId {
    static type = ClassesCalendarActionTypes.SetSelectedClubId;
    constructor(public clubId: string) {}
}
export class InitClassesCalendarFiltersFormAction {
  static type = ClassesCalendarActionTypes.InitClassesCalendarFiltersForm;
}

export class LoadClassesCalendarAction {
  static type = ClassesCalendarActionTypes.LoadClassesCalendar;
  constructor(public query: GetGroupClassesCalendarQuery) {}
}

export class LoadClassesCalendarSuccessAction {
  static type = ClassesCalendarActionTypes.LoadClassesCalendarSuccess;
  constructor(
      public events: BcCalendarEvent[],
      public resources: BcCalendarResource[],
      public settings: BcCalendarSettings
  ) {}
}

export class LoadClassesCalendarContextAction {
  static type = ClassesCalendarActionTypes.LoadClassesCalendarContext;
}

export class LoadClassesCalendarContextSuccessAction {
  static type = ClassesCalendarActionTypes.LoadClassesCalendarContextSuccess;
  constructor(public settings: BcCalendarSettings) {}
}
